import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';

class AreaInput extends React.Component {
    render() {
        // we open up props to textare
        const {placeholder, value, name, onChange, label, type, marginTop, ...rest} = this.props;
        return(
            <Flex column className={style.InformationFormsWrapper} marginTop={marginTop} width='100%' {...rest}>
                <TextareaAutosize
                    className={style.FormStyle}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    name={name}
                    onChange={onChange}
                    rows={this.props.rows}
                    disabled={this.props.disabled}
                />
            </Flex>
        );
    }
}
/**
 * @placeholder: Placeholder for the inputfield. Not required.
 * @label: Label above the inputfield. Not required.
 * @value: Value for the inputfield. Not required.
 * @autoComplete: Autocomplete for the field e.g. email, organization. Required.
 * @width: Width of the textinput. Not required.
 * @height: Height of the textinput. Not required.
 * @name: Name for the textinput when using onChange event. Required.
 * @type: Type of the inputfield e.g. password. Default is text. Not required.
 * @marginTop: Adjust marginTop of the component. Not required
 */
AreaInput.propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    marginTop: PropTypes.string,
  };

export default AreaInput;



// WEBPACK FOOTER //
// ./src/component/Forms/AreaInput/index.js